const centralFileBackup = {
  state: {
    downFileList: []
  },

  mutations: {
    SET_DOWNFILELIST(state, data) {
      state.downFileList = data;
    }
  },

  actions: {
    setDownFileList({ commit }, data) {
      commit('SET_DOWNFILELIST', data);
    }
  }
};

export default centralFileBackup;
